import { useTranslation } from "react-i18next";
import { Button } from "~/components/ui/button";
import { Link } from "~/components/ui/link";
import { Picture } from "~/components/ui/picture";
import type { ProductAllFeaturesBanner } from "~/data/products/types";

interface ShopFeaturesBannerProps {
  content: ProductAllFeaturesBanner;
}

export function ShopFeaturesBanner({ content }: ShopFeaturesBannerProps) {
  const { t } = useTranslation("products");
  return (
    <section className="bg-text-heading relative isolate overflow-hidden md:aspect-[1440/367]">
      <Picture
        src={content.image}
        alt=""
        aria-hidden
        className="absolute top-[-31%] left-[-13%] h-[170%] w-[170%] max-w-none md:top-0 md:left-0 md:size-full md:object-cover md:object-center"
      />
      <div className="bg-text-heading/70 absolute inset-0 md:bg-white/10" />
      <div className="from-text-heading/70 to-text-heading/0 absolute inset-0 hidden bg-gradient-to-l from-[21.944%] to-[87.639%] md:block" />
      <div className="wrap relative z-1 flex flex-col items-center gap-6 py-12 text-center md:h-full md:items-end md:justify-center md:py-0 md:text-right">
        <h2 className="font-display max-w-[237px] text-xl leading-[1.15] font-extrabold text-white md:max-w-[483px] md:text-4xl md:leading-[1.1]">
          {t(content.headline)}
        </h2>
        <Button
          asChild
          data-sid="all-features-shop-cta"
          variant="primary"
          size="default"
          className="md:h-14 md:text-base md:leading-5 md:tracking-[0.16px]"
        >
          <Link to={content.ctaHref} data-sid="all-features-shop-link">{t(content.ctaLabel)}</Link>
        </Button>
      </div>
    </section>
  );
}
